// LineChart.js
import { Bar, mixins } from 'vue-chartjs'
const { reactiveProp} = mixins

export default {
  extends: Bar,
  mixins: [reactiveProp],
  name: 'BarChart',
  props: ['options'],
  data:() =>({
    chart:null
  }),
  mounted () {     
      const me = this      
      this.renderChart(this.chartData, {...this.options ,onClick:function(evt) {
            me.chart = this.chart
            const elt = this.chart?.getElementAtEvent(evt)?.at(0)
            if(elt) {
              me.$emit('onPointClick',elt._index)              
            } 
          } 
      })   
  }
}